module.exports = __webpack_public_path__ + "img/ux9702.31e7ff2d.jpg";